// extracted by mini-css-extract-plugin
export default {"tabs":"index_tabs_Vo9e8","current":"index_current_1XHOI","item":"index_item_4-fS0","dot":"index_dot_ep7l4"};